import React from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Panel, Empty } from '../programme/insights/HeadlineCards';
import { API_BASE } from '../../config/api';

export const API = `${API_BASE}/api`;
const AXIS = { stroke: '#52525b', fontSize: 11, tickLine: false, axisLine: false };
const TIP = { contentStyle: { background: '#18181b', border: '1px solid #3f3f46', borderRadius: 12, fontSize: 12 }, labelStyle: { color: '#fafafa' }, cursor: { fill: 'rgba(255,255,255,0.04)' } };

export const fmtDate = (v, time = false) => (v ? new Date(v).toLocaleString('en-ZA', time ? { dateStyle: 'medium', timeStyle: 'short' } : { dateStyle: 'medium' }) : '—');
export const pct = (v) => (v === null || v === undefined ? '—' : `${v}%`);

export const StatGrid = ({ stats }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
    {stats.map(({ key, label, value, sub, tone = 'text-white' }) => (
      <div key={key} className="rounded-2xl border border-zinc-800 bg-zinc-950/60 p-5" data-testid={`analytics-stat-${key}`}>
        <p className={`text-2xl font-semibold tabular-nums ${tone}`} data-testid={`analytics-value-${key}`}>{value}</p>
        <p className="text-xs text-zinc-500 mt-1">{label}{sub ? ` · ${sub}` : ''}</p>
      </div>
    ))}
  </div>
);

export const LoginChart = ({ data, title = 'Logins — last 30 days' }) => (
  <Panel title={title} testId="analytics-login-chart">
    {!data.some((d) => d.count) ? <Empty>No logins recorded in the last 30 days.</Empty> : (
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={data} margin={{ left: -24, right: 8 }}>
          <CartesianGrid vertical={false} stroke="#27272a" />
          <XAxis dataKey="date" {...AXIS} tickFormatter={(d) => d.slice(5)} interval={4} />
          <YAxis allowDecimals={false} {...AXIS} />
          <Tooltip {...TIP} formatter={(v) => [v, 'Logins']} />
          <Bar dataKey="count" fill="#14b8a6" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    )}
  </Panel>
);

export const DataTable = ({ testId, columns, rows, empty, onRowClick }) => (
  <div className="overflow-x-auto" data-testid={testId}>
    {!rows.length ? <Empty>{empty}</Empty> : (
      <table className="w-full text-sm">
        <thead><tr className="text-left text-xs text-zinc-500 uppercase border-b border-zinc-800">
          {columns.map((c) => <th key={c.label} className="py-2 pr-4 font-medium whitespace-nowrap">{c.label}</th>)}
        </tr></thead>
        <tbody className="divide-y divide-zinc-800/70">
          {rows.map((r, i) => (
            <tr key={r.key || i} onClick={onRowClick ? () => onRowClick(r) : undefined} className={onRowClick ? 'cursor-pointer hover:bg-zinc-800/40' : ''} data-testid={r.testId}>
              {columns.map((c) => <td key={c.label} className="py-2.5 pr-4 text-zinc-300 whitespace-nowrap">{c.render(r)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);

export async function downloadXlsx(url, token, filename) {
  try {
    const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob' });
    const href = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = href;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(href);
  } catch {
    toast.error('Export failed');
  }
}
